/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Datetimebeforetodayaspect14Inputs */

const de__class_datetimebeforetodayaspect14 = /** @type {(inputs: _Class_Datetimebeforetodayaspect14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vor heute relativ`)
};

/**

* @param {_Class_Datetimebeforetodayaspect14Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_datetimebeforetodayaspect14 = /** @type {((inputs?: _Class_Datetimebeforetodayaspect14Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Datetimebeforetodayaspect14Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_datetimebeforetodayaspect14(inputs)
});
export { _class_datetimebeforetodayaspect14 as "_class_DateTimeBEFORETODAYAspect" }